/* Quick Buy: sticky bottom bar, options sheet and added-to-cart sheet. */
if (!customElements.get('qb-sticky-buy')) {
  class QbStickyBuy extends HTMLElement {
    connectedCallback() {
      if (this.qbReady) return;
      this.qbReady = true;
      try {
        this.data = JSON.parse(this.querySelector('[data-qb-data]').textContent);
      } catch (e) {
        return;
      }
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      this.lowStock = parseInt(this.dataset.lowStock || '10', 10);
      this.qty = 1;
      this.variant =
        this.data.variants.find((v) => v.id === this.data.selected) ||
        this.data.variants.find((v) => v.available) ||
        this.data.variants[0];
      this.sheet = this.querySelector('[data-sheet]');
      this.pairsLoaded = false;
      this.addLabel = this.q('[data-add-label]').textContent.trim();

      this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => this.openPick()));
      this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.sheet.close()));
      this.sheet.addEventListener('click', (e) => {
        if (e.target === this.sheet) this.sheet.close();
      });
      this.q('[data-add]').addEventListener('click', () => this.add(this.variant.id, this.qty, true));
      this.q('[data-sheet-add]').addEventListener('click', () => this.add(this.variant.id, this.qty, true));
      this.q('[data-buy-now]').addEventListener('click', () => {
        if (!this.variant || !this.variant.available) return;
        window.location.href = this.root + 'cart/' + this.variant.id + ':' + this.qty;
      });
      this.q('[data-dec]').addEventListener('click', () => {
        this.qty = Math.max(1, this.qty - 1);
        this.render();
      });
      this.q('[data-inc]').addEventListener('click', () => {
        this.qty = Math.min(this.maxQty(), this.qty + 1);
        this.render();
      });
      this.q('[data-view-cart]').addEventListener('click', () => {
        this.sheet.close();
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = this.root + 'cart';
      });

      this.onVariant = (event) => {
        const d = event.detail || {};
        if (!d.resource || String((d.data || {}).productId) !== String(this.dataset.productId)) return;
        const v = this.data.variants.find((x) => String(x.id) === String(d.resource.id));
        if (v) {
          this.variant = v;
          this.qty = Math.min(this.qty, this.maxQty());
          this.render();
        }
      };
      document.addEventListener('variant:update', this.onVariant);

      this.pill = document.createElement('span');
      this.pill.className = 'qb-sb__pill';
      this.pill.hidden = true;
      /* "Save X%" sits next to the price, so it never covers or floats above the photo. */
      const price = document.querySelector('product-price[data-product-id="' + this.dataset.productId + '"]');
      if (price) price.insertAdjacentElement('afterend', this.pill);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariant);
    }

    q(sel) {
      return this.querySelector(sel);
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: this.currency,
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    maxQty() {
      const v = this.variant;
      if (!v || v.qty === null || v.qty === undefined) return 99;
      return Math.max(1, v.qty);
    }

    render() {
      const v = this.variant;
      if (!v) return;
      const img = v.image || this.data.image;
      const summary = this.q('[data-summary]');
      if (summary) summary.textContent = v.options.join(' · ');
      const thumb = this.q('[data-thumb]');
      if (thumb && img) {
        thumb.src = img;
        thumb.hidden = false;
      }
      const headImg = this.q('[data-head-img]');
      if (headImg && img) {
        headImg.src = img;
        headImg.hidden = false;
      }
      const line = this.money(v.price * this.qty);
      const soldOut = !v.available;
      this.q('[data-add-label]').textContent = soldOut ? 'Sold out' : this.addLabel;
      this.q('[data-add-price]').textContent = soldOut ? '' : ' · ' + line;
      this.q('[data-add]').disabled = soldOut;
      this.q('[data-sheet-add-label]').textContent = soldOut ? 'Sold out' : this.addLabel;
      this.q('[data-sheet-add-price]').textContent = soldOut ? '' : ' · ' + line;
      this.q('[data-sheet-add]').disabled = soldOut;
      this.q('[data-buy-now]').disabled = soldOut;
      this.q('[data-head-price]').textContent = this.money(v.price);
      this.q('[data-head-compare]').textContent = v.compare > v.price ? this.money(v.compare) : '';
      this.q('[data-qty]').textContent = String(this.qty);
      let stock = '';
      if (soldOut) stock = 'Sold out';
      else if (v.qty !== null && v.qty !== undefined && v.qty > 0 && v.qty <= this.lowStock) stock = 'Only ' + v.qty + ' left';
      this.q('[data-stock]').textContent = stock;
      if (this.pill) {
        if (v.compare > v.price) {
          this.pill.textContent = 'Save ' + Math.round((1 - v.price / v.compare) * 100) + '%';
          this.pill.hidden = false;
        } else {
          this.pill.hidden = true;
        }
      }
      this.renderOptions();
    }

    renderOptions() {
      const wrap = this.q('[data-options]');
      if (!wrap || !this.data.options || this.data.options.length === 0 || this.dataset.hasOptions !== 'true') {
        if (wrap) wrap.hidden = true;
        return;
      }
      wrap.textContent = '';
      this.data.options.forEach((name, i) => {
        const group = document.createElement('div');
        group.className = 'qb-sb__group';
        const label = document.createElement('span');
        label.className = 'qb-sb__group-label';
        label.textContent = name + ': ';
        const val = document.createElement('span');
        val.className = 'qb-sb__group-value';
        val.textContent = this.variant.options[i];
        label.appendChild(val);
        group.appendChild(label);
        const row = document.createElement('div');
        const isColor = /colou?r|pattern|style/i.test(name);
        row.className = 'qb-sb__choices' + (isColor ? ' qb-sb__choices--tiles' : '');
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-label', name);
        const values = [];
        this.data.variants.forEach((v) => {
          if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]);
        });
        values.forEach((value) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('role', 'radio');
          const on = this.variant.options[i] === value;
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.className = 'qb-sb__choice' + (on ? ' is-on' : '');
          const anyAvail = this.data.variants.some((v) => v.options[i] === value && v.available);
          if (!anyAvail) btn.classList.add('is-out');
          if (isColor) {
            const withImg = this.data.variants.find((v) => v.options[i] === value && v.image);
            if (withImg) {
              const im = document.createElement('img');
              im.src = withImg.image;
              im.alt = '';
              im.width = 44;
              im.height = 44;
              im.loading = 'lazy';
              btn.appendChild(im);
            }
          }
          const t = document.createElement('span');
          t.textContent = value;
          btn.appendChild(t);
          if (!anyAvail) {
            const s = document.createElement('small');
            s.textContent = 'Sold out';
            btn.appendChild(s);
          }
          btn.addEventListener('click', () => this.pick(i, value));
          row.appendChild(btn);
        });
        group.appendChild(row);
        wrap.appendChild(group);
      });
    }

    pick(i, value) {
      const want = this.variant.options.slice();
      want[i] = value;
      let v = this.data.variants.find((x) => x.options.every((o, k) => o === want[k]));
      const note = this.q('[data-note]');
      note.hidden = true;
      if (!v) {
        v =
          this.data.variants.find((x) => x.options[i] === value && x.available) ||
          this.data.variants.find((x) => x.options[i] === value);
        if (v) {
          const changed = [];
          v.options.forEach((o, k) => {
            if (k !== i && o !== want[k]) changed.push(this.data.options[k] + ' to ' + o);
          });
          if (changed.length) {
            note.textContent = value + ' comes in a different option, so we switched ' + changed.join(' and ') + '.';
            note.hidden = false;
          }
        }
      }
      if (!v) return;
      this.variant = v;
      this.qty = Math.min(this.qty, this.maxQty());
      this.render();
      this.syncMain(v);
    }

    syncMain(v) {
      const picker = document.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
      if (!picker) return;
      v.options.forEach((value, i) => {
        const inputs = picker.querySelectorAll('input[data-fieldset-index="' + i + '"]');
        inputs.forEach((input) => {
          if (input.value === value && !input.checked) input.click();
        });
        const select = picker.querySelectorAll('select')[i];
        if (select && select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    openPick() {
      this.showView('pick');
      this.q('[data-error]').hidden = true;
      if (!this.sheet.open) this.sheet.showModal();
    }

    showView(name) {
      this.q('[data-view-pick]').hidden = name !== 'pick';
      this.q('[data-view-added]').hidden = name !== 'added';
      this.sheet.setAttribute('aria-label', name === 'added' ? 'Added to cart' : 'Choose options');
    }

    sectionIds() {
      return Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((el) => el.dataset.sectionId);
    }

    async add(id, qty, isMain, button) {
      const btn = button || (this.sheet.open ? this.q('[data-sheet-add]') : this.q('[data-add]'));
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }], sections: this.sectionIds().join(',') }),
        });
        const json = await res.json();
        if (json.status) {
          const err = this.q('[data-error]');
          err.textContent = json.description || json.message || 'Could not add to cart.';
          err.hidden = false;
          if (!this.sheet.open) this.openPick();
          return false;
        }
        const cart = await (await fetch(this.root + 'cart.js')).json();
        this.announce(cart, json.sections);
        this.q('[data-cart-line]').textContent =
          'Cart: ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' · ' + this.money(cart.total_price);
        if (isMain) {
          this.showView('added');
          if (!this.sheet.open) this.sheet.showModal();
          this.loadPairs();
        }
        return true;
      } catch (e) {
        return false;
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
      }
    }

    announce(cart, sections) {
      const drawer = document.querySelector('cart-drawer-component');
      const auto = drawer && drawer.hasAttribute('auto-open');
      if (auto) drawer.removeAttribute('auto-open');
      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: cart,
        sourceId: 'qb-sticky-buy',
        data: { source: 'qb-sticky-buy', itemCount: cart.item_count, productId: this.dataset.productId, sections: sections || {} },
      };
      this.dispatchEvent(ev);
      if (auto) drawer.setAttribute('auto-open', '');
    }

    async loadPairs() {
      if (this.pairsLoaded) return;
      this.pairsLoaded = true;
      const base = this.root + 'recommendations/products.json?limit=3&product_id=' + this.dataset.productId;
      let products = [];
      try {
        products = (await (await fetch(base + '&intent=complementary')).json()).products || [];
        if (!products.length) products = (await (await fetch(base + '&intent=related')).json()).products || [];
      } catch (e) {
        products = [];
      }
      products = products.filter((p) => p.available).slice(0, 3);
      const list = this.q('[data-pairs]');
      list.textContent = '';
      products.forEach((p) => {
        const variant = (p.variants || []).find((v) => v.available);
        if (!variant) return;
        const hasOptions = (p.variants || []).length > 1;
        const li = document.createElement('li');
        li.className = 'qb-sb__pair';
        const a = document.createElement('a');
        a.href = p.url;
        a.className = 'qb-sb__pair-img';
        if (p.featured_image) {
          const im = document.createElement('img');
          im.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          im.alt = '';
          im.width = 52;
          im.height = 52;
          im.loading = 'lazy';
          a.appendChild(im);
        }
        const text = document.createElement('span');
        text.className = 'qb-sb__pair-text';
        const title = document.createElement('a');
        title.href = p.url;
        title.textContent = p.title;
        const price = document.createElement('strong');
        price.textContent = (hasOptions && p.price_varies ? 'From ' : '') + this.money(hasOptions ? p.price : variant.price);
        text.appendChild(title);
        text.appendChild(price);
        let btn;
        if (hasOptions) {
          btn = document.createElement('a');
          btn.href = p.url;
          btn.className = 'qb-sb__pair-add';
          btn.style.display = 'inline-flex';
          btn.style.alignItems = 'center';
          btn.style.justifyContent = 'center';
          btn.style.textDecoration = 'none';
          btn.textContent = 'Choose';
          btn.setAttribute('aria-label', 'Choose options: ' + p.title);
        } else {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qb-sb__pair-add';
          btn.textContent = '+ Add';
          btn.setAttribute('aria-label', 'Add ' + p.title);
          btn.addEventListener('click', async () => {
            if (btn.classList.contains('is-added')) return;
            const ok = await this.add(variant.id, 1, false, btn);
            if (ok) {
              btn.classList.add('is-added');
              btn.textContent = 'Added';
            }
          });
        }
        li.appendChild(a);
        li.appendChild(text);
        li.appendChild(btn);
        list.appendChild(li);
      });
      this.q('[data-pairs-wrap]').hidden = list.children.length === 0;
    }
  }
  customElements.define('qb-sticky-buy', QbStickyBuy);
}